/**
 * Demo Mode Inline Note
 * Small inline indicator for demo mode panels
 */

import { FlaskConical } from 'lucide-react';
import { cn } from '@/lib/utils';

interface DemoModeInlineNoteProps {
  className?: string;
}

export function DemoModeInlineNote({ className }: DemoModeInlineNoteProps) {
  return (
    <div className={cn(
      "flex items-center gap-1.5 text-xs text-warning",
      className
    )}>
      <FlaskConical className="w-3 h-3" />
      <span>Demo mode: simulated data shown for illustration.</span>
    </div>
  );
}
